export default __webpack_public_path__ + "static/media/bhanga-kanch.778b87ca.jpg";